import type { IUtils } from '@date-io/core/IUtils'
import { useContext } from 'react'

import { MuiPickersContext } from '../../MuiPickersUtilsProvider'
import type { MaterialUiPickersDate } from '../../typings/date'

export const checkUtils = (utils: IUtils<MaterialUiPickersDate> | null | undefined) => {
  if (!utils) {
    // tslint:disable-next-line
    throw new Error(
      'Can not find utils in context. You either a) forgot to wrap your component tree in MuiPickersUtilsProvider; or b) mixed named and direct file imports.  Recommendation: use named imports from the module index.',
    )
  }
}

export function useUtils() {
  const utils = useContext(MuiPickersContext)
  checkUtils(utils)

  return utils!
}
